import React from 'react';

export const VendorTable = ({ vendors }) => (
  <div className="rounded-2xl border bg-card overflow-hidden" data-testid="scout-vendor-table">
    <div className="p-4 border-b">
      <h3 className="text-sm font-bold">Vendor fraud rate</h3>
      <p className="text-xs text-muted-foreground mt-0.5">Latest Scout verdict per candidate, grouped by the vendor or source that sent them.</p>
    </div>
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground border-b">
          {['Vendor', 'Scanned', 'Review', 'High Risk', 'Fraud rate'].map((h) => <th key={h} className="px-4 py-2.5 font-semibold">{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {vendors.map((v) => (
          <tr key={v.vendor} className="border-b last:border-0" data-testid={`scout-vendor-row-${v.vendor}`}>
            <td className="px-4 py-3 font-medium">{v.vendor}</td>
            <td className="px-4 py-3 tabular-nums">{v.total}</td>
            <td className="px-4 py-3 tabular-nums text-amber-600 dark:text-amber-400">{v.review}</td>
            <td className="px-4 py-3 tabular-nums text-red-600 dark:text-red-400">{v.high_risk}</td>
            <td className="px-4 py-3">
              <div className="flex items-center gap-2">
                <div className="h-1.5 w-24 rounded-full bg-muted overflow-hidden">
                  <div className={`h-full rounded-full ${v.fraud_rate >= 30 ? 'bg-red-500' : v.fraud_rate >= 10 ? 'bg-amber-500' : 'bg-emerald-500'}`} style={{ width: `${Math.max(v.fraud_rate, 3)}%` }} />
                </div>
                <span className="text-xs font-semibold tabular-nums">{v.fraud_rate}%</span>
              </div>
            </td>
          </tr>
        ))}
        {!vendors.length && <tr><td colSpan={5} className="text-center text-sm text-muted-foreground py-14" data-testid="scout-vendors-empty">No vendor data yet — vendors come from Ceipal imports, bulk CSV or the quick-check form.</td></tr>}
      </tbody>
    </table>
  </div>
);

export default VendorTable;
